import { GatsbyImage } from 'gatsby-plugin-image';
import get from 'lodash.get';
import React from 'react';

import RichTextConverter from '../Common/RichText/RichTextConverter';
import HeadingCtas from '../Generic/HeadingCtas';
import PageSection from '../PageSections/PageSection';
import * as styles from './OverUnderHeader.module.scss';

const OverUnderHeader = ({ image, lede, heading, ctaLabel, onCtaClick, ctas }) => {
  let heroImage;
  if (get(image, 'file.contentType') === 'image/svg+xml') {
    heroImage = (
      <img
        loading={'eager'}
        fetchpriority={'high'}
        src={image.file.url}
        alt={image.title}
        className={styles.heroImage}
        data-analytics-component={'header-image'}
      />
    );
  } else {
    heroImage = (
      <GatsbyImage
        loading={'eager'}
        fetchpriority={'high'}
        alt={get(image, 'title')}
        className={styles.heroImage}
        image={get(image, 'gatsbyImageData')}
        data-analytics-component={'header-image'}
      />
    );
  }
  return (
    <PageSection isTopSection={true} wide data-analytics-section={'over-under-header'}>
      <div className={styles.heroGrid}>
        <div className={styles.headingContainer} data-analytics-component={'header-copy'} data-analytics-id={heading}>
          <h1>{heading}</h1>
          {lede && <RichTextConverter copy={lede} />}
        </div>
        {ctas && (
          <div className={styles.ctaContainer}>
            <HeadingCtas ctas={ctas} />
          </div>
        )}
        {heroImage}
      </div>
    </PageSection>
  );
};

OverUnderHeader.propTypes = {
  // myProp: PropTypes.string.isRequired
};

export default OverUnderHeader;
